import { render } from "./icon-button.vue?vue&type=template&id=2381125a&ts=true"
import script from "./icon-button.vue?vue&type=script&lang=ts"
export * from "./icon-button.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__